import { motion, useReducedMotion } from "framer-motion";
import { ArrowRight, Check } from "lucide-react";

const EASE = [0.22, 1, 0.36, 1];

function MaskedLine({ children, delay = 0, className = "" }) {
  const reduce = useReducedMotion();
  return (
    <span className="block overflow-hidden pb-[0.18em] -mb-[0.18em] pt-[0.3em] -mt-[0.3em]">
      <motion.span
        className={`block ${className}`}
        initial={reduce ? false : { y: "140%" }}
        animate={{ y: "0%" }}
        transition={{ duration: 0.8, ease: EASE, delay }}
      >
        {children}
      </motion.span>
    </span>
  );
}

function FadeUp({ children, delay = 0, className = "" }) {
  const reduce = useReducedMotion();
  return (
    <motion.div
      className={className}
      initial={reduce ? false : { opacity: 0, y: 16 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.6, ease: EASE, delay }}
    >
      {children}
    </motion.div>
  );
}

const BENEFITS = [
  "Înțelegi tiparul tău",
  "Vezi cât de des folosești telefonul neintenționat",
  "Primești un plan simplu de 3 zile",
];

export function Intro({ onStart }) {
  return (
    <main data-testid="intro-screen" className="pb-4 pt-16 sm:pt-20">
      <FadeUp delay={0.02}>
        <p className="text-[12px] font-semibold uppercase tracking-[0.22em] text-teal">
          Quiz MindRegen
        </p>
      </FadeUp>

      <h1 className="mt-7 font-display text-[1.75rem] font-bold leading-[1.22] tracking-tight sm:text-5xl sm:leading-[1.18]">
        <MaskedLine delay={0.12}>Îți controlezi telefonul</MaskedLine>
        <MaskedLine delay={0.24}>
          sau telefonul îți controlează <span className="text-teal">atenția?</span>
        </MaskedLine>
      </h1>

      <FadeUp delay={0.4}>
        <p className="mt-6 text-base leading-relaxed text-soft sm:text-lg">
          Află de ce ajungi să deschizi telefonul automat, să pierzi timp în scroll sau să amâni
          lucruri importante.
        </p>
      </FadeUp>

      <FadeUp delay={0.48}>
        <p className="mt-3 text-[15px] font-medium text-ink/90">
          Primești un rezultat simplu și o acțiune concretă pe care o poți aplica chiar de azi.
        </p>
      </FadeUp>

      <FadeUp delay={0.56}>
        <ul className="mt-7 space-y-2.5">
          {BENEFITS.map((b, i) => (
            <li key={i} className="flex items-center gap-3 text-[15px] text-ink/90">
              <span className="flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-teal/15">
                <Check className="h-3.5 w-3.5 text-teal" aria-hidden="true" />
              </span>
              {b}
            </li>
          ))}
        </ul>
      </FadeUp>

      <FadeUp delay={0.66} className="mt-9">
        <button
          data-testid="start-quiz-button"
          onClick={onStart}
          className="glow-cta inline-flex min-h-[56px] w-full items-center justify-center gap-2 rounded-full bg-teal px-10 font-display text-[15px] font-bold uppercase tracking-wide text-base transition-[background-color,box-shadow] duration-200 hover:bg-teal-dark sm:w-auto"
        >
          Începe testul
          <ArrowRight className="h-4 w-4" aria-hidden="true" />
        </button>
        <p className="mt-4 text-sm text-soft" data-testid="hero-sub-cta">
          8 întrebări · aproximativ 2 minute
        </p>
      </FadeUp>

    </main>
  );
}
